import React from 'react';
import styled from 'styled-components';
import { CONSTS } from '../elements/_constants';
import { AppState } from '../../store';
import { connect } from 'react-redux';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { logOut } from '../../store/base/functions';
import Link from '../elements/link';
type topBarProps = {
    className?: string,
    currentPathName: string,
    lab: any,
    onLogOut: Function
}
const TopBar = (props: topBarProps) => {
    return (
        <StyleNav className={props.className}>
            <div className="meta-desc">
                {props.lab && props.lab.name}
            </div>
            <div className="user-menu">
            {/* <SwitchTransition>
                <CSSTransition
                    key={(props.currentPathName != "/").toString()}
                    timeout={{ enter: 300, exit: 300 }}
                    classNames="fade"
                >
                    <div>
                    {
                        (props.currentPathName != "/") &&
                        <div className="header-search-box">
                            <div className="_icon icon-icons8-search"/>
                            <input placeholder="جستجو"/>
                        </div>
                    }
                    </div>
                </CSSTransition>
            </SwitchTransition> */}

            <Link to="/profile">
                <li>
                    <div className="_icon icon-icons8-user"/>
                    <div className="_title">
                        پروفایل کاربری
                    </div>
                </li>
            </Link>
                <li onClick={()=>props.onLogOut()}>
                    <div className="_icon icon-icons8-logout_rounded_up"/>
                </li>
            </div>
        </StyleNav>
    )
}

const StyleNav = styled.div`
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
        opacity: 0;
        * {
            display: none;
        }
    }
    width: 100%;
    height: 60px;
    background: ${CONSTS.colors.primary};
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    .meta-desc{
        color: #fff;
        margin-right: 15px;
    }
    .user-menu {
        display: flex;
        align-items: center;
        flex-direction: row;
        .header-search-box {
            margin-left: 10px;
            min-width: 250px;
            height: 40px;
            background: rgba(255,255,255,0.05);
            border-radius: 21.5px;
            position: relative;
            overflow: hidden;
            input {
                width: calc(100% - 40px);
                border: 0;
                outline: none;
                background: transparent;
                height: 100%;
                font-family: ${CONSTS.fonts.primary.light};
                font-size: 14px;
                padding-right: 15px;
                box-sizing: border-box;
                color: white;
                transition: ease background .2s;
                &::placeholder {
                    color: rgba(255,255,255,.3);
                }
                &:hover {
                    background: rgba(255,255,255,0.02);
                }
                &:focus {
                    background: rgba(255,255,255,0.05);
                }
            }
            ._icon {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row;
                top: 2.5px;
                left: 2.5px;
                width: 35px;
                height: 35px;
                font-size: 23px;
                color: white;
                cursor: pointer;
                transition: cubic-bezier(0.52, 0.01, 0.56, 1.34) all .2s;
                z-index: 1000;
                &:hover {
                    opacity: .8;
                    transform: scale(1.05);
                }
                &:active {
                    transform: scale(0.97);
                }
            }
        }
        li {
            cursor: pointer;
            margin-left: 10px;
            list-style: none;
            background: rgba(255,255,255,0.05);
            transition: ease background .2s,ease transform .2s;
            transform: scale(1);
            border-radius: 21.5px;
            color: white;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: center;
            height: 40px;
            padding: 5px;
            box-sizing: border-box;
            @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
                ._title {
                    display: none;
                }    
            }
            ._title {
                font-family: ${CONSTS.fonts.primary.medium};
                font-size: 13px;
                padding-right: 2px;
                padding-left: 12px;
            }
            ._icon {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row;
                width: 35px;
                height: 35px;
                font-size: 25px;
            }
            &:hover {
                transform: scale(1.05);
                background: rgba(255,255,255,0.09);
            }
            &:active {
                transform: scale(0.97);
            }
        }
    }
`

const mapStateToProps = (state: AppState) => ({
    currentPathName: state.base.path,
    lab            : state.base.lab
});
const mapDispatchToProps = (dispatch:any) => {
    return {
      onLogOut       : ()                =>{
        dispatch(logOut());
      },
    };
  };
export default connect(
    mapStateToProps,mapDispatchToProps
)(TopBar);